import { JsonObject, JsonProperty } from 'json2typescript';
import { UserWelcomeMessage } from './userWelcomeMessage';
import { Machine } from './machine';
import { SFAccount } from './sf-account';

@JsonObject('User')
export class User {
  @JsonProperty('id', String)
  public id?: string = undefined;
  @JsonProperty('sfContactId', String)
  public sfContactId?: string = undefined;
  @JsonProperty('permissions', [String])
  public permissions?: string[] = undefined;
  @JsonProperty('role', String)
  public role?: string = undefined;
  @JsonProperty('firstName', String)
  public firstName?: string = undefined;
  @JsonProperty('lastName', String)
  public lastName?: string = undefined;
  @JsonProperty('email', String)
  public email?: string = undefined;
  @JsonProperty('mobilePhone', String)
  public mobilePhone?: string = undefined;
  @JsonProperty('machines', [Machine])
  public machines?: Machine[] = undefined;
  @JsonProperty('accounts', [SFAccount])
  public accounts?: SFAccount[] = undefined;
  @JsonProperty('createdDate', String)
  public createdDate?: string = undefined;
  @JsonProperty('modifiedDate', String)
  public modifiedDate?: string = undefined;
  @JsonProperty('status', String)
  public status?: string = undefined;
  @JsonProperty('password', String)
  public password?: string = undefined;
  @JsonProperty('templateMail', UserWelcomeMessage)
  public templateMail?: UserWelcomeMessage = undefined;
  @JsonProperty('companyGroupId', String, true)
  public companyGroupId?: string = undefined;
  @JsonProperty('canImpersonate', Boolean, true)
  public canImpersonate?: boolean = undefined;
}
